module.exports = __webpack_public_path__ + "img/me.ff1f4ee6.jpg";